// extracted by css-extract-rspack-plugin
export default {"cls1":"LanguageRow-cls1_9nQ","cls2":"LanguageRow-cls2__6a LanguageRow-cls1_9nQ"};